export type SundayServiceTextVariant = 'compact' | 'seasonalSummary' | 'seasonalDescription';

const MORNING_SERVICE_TIME = '9:30';
const WINTER_EVENING_SERVICE_TIME = '16:30';
const SUMMER_EVENING_SERVICE_TIME = '19:00';

type SundayServiceTimes = {
  morning: string;
  evening: string;
  isSummerTime: boolean;
};

function getAmsterdamDateParts(date: Date): { year: number; month: number; day: number } {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Amsterdam',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });

  const parts = formatter.formatToParts(date);
  const year = Number(parts.find((part) => part.type === 'year')?.value);
  const month = Number(parts.find((part) => part.type === 'month')?.value);
  const day = Number(parts.find((part) => part.type === 'day')?.value);

  return { year, month, day };
}

function getLastSundayOfMonth(year: number, month: number): number {
  const lastDayOfMonth = new Date(Date.UTC(year, month, 0));
  const lastDay = lastDayOfMonth.getUTCDate();
  const weekday = lastDayOfMonth.getUTCDay();

  return lastDay - weekday;
}

export function isDutchSummerTime(date = new Date()): boolean {
  const { year, month, day } = getAmsterdamDateParts(date);

  if (month < 3 || month > 10) {
    return false;
  }

  if (month > 3 && month < 10) {
    return true;
  }

  if (month === 3) {
    return day >= getLastSundayOfMonth(year, 3);
  }

  return day < getLastSundayOfMonth(year, 10);
}

export function getSundayServiceTimes(date = new Date()): SundayServiceTimes {
  const summerTime = isDutchSummerTime(date);

  return {
    morning: MORNING_SERVICE_TIME,
    evening: summerTime ? SUMMER_EVENING_SERVICE_TIME : WINTER_EVENING_SERVICE_TIME,
    isSummerTime: summerTime
  };
}

export function getSundayServiceText(
  variant: SundayServiceTextVariant = 'seasonalSummary',
  date = new Date()
): string {
  const { morning, evening } = getSundayServiceTimes(date);

  if (variant === 'compact') {
    return `Zondag: ${morning} en ${evening}`;
  }

  if (variant === 'seasonalDescription') {
    return `De tweede dienst begint in de wintertijd om ${WINTER_EVENING_SERVICE_TIME} uur en in de zomertijd om ${SUMMER_EVENING_SERVICE_TIME} uur.`;
  }

  return `Zondag: ${morning} en ${WINTER_EVENING_SERVICE_TIME} (wintertijd) / ${SUMMER_EVENING_SERVICE_TIME} (zomertijd)`;
}
